import { Button, Tag, Row, Grid } from "antd";
import { observer } from "mobx-react";
import { useMobxStores } from "../../stores/stores";
import "../../pages/Marketplace.css";
const { useBreakpoint } = Grid;

const FilterOptions = () => {
  const screens = useBreakpoint();

  // Decide a "size" label based on breakpoints
  const getSize = () => {
    if (screens.xxl || screens.xl) return "lg";
    if (screens.lg || screens.md) return "md";
    return "sm";
  };

  const size = getSize();

  // const tagStyleBySize = {
  //   lg: {
  //     width: "90px",
  //     padding: "4px 8px",
  //     fontSize: "16px",
  //     borderRadius: "16px",
  //   },
  //   md: {
  //     width: "78px",
  //     padding: "4px 2px",
  //     fontSize: "14px",
  //     borderRadius: "16px",
  //   },
  //   sm: {
  //     width: "68px",
  //     padding: "2px 2px",
  //     fontSize: "12px",
  //     borderRadius: "16px",
  //   },
  // };

  const { marketplaceStore } = useMobxStores();

  const onClick = (values) => {
    marketplaceStore.GetMarketplaceItemsByTypeOrName(values);
    marketplaceStore.setActiveFilter(values.value);
  };

  const OnResetFiltering = () => {
    marketplaceStore.GetMarketplaceItems();
    marketplaceStore.setActiveFilter(null);
  };

  const types_list = [
    { name: "Software", type: "type", color: "blue", value: "software" },
    { name: "3D", type: "type", color: "brown", value: "3D" },
    { name: "Dataset", type: "type", color: "pink", value: "dataset" },
    { name: "Text", type: "type", color: "green", value: "text" },
    { name: "MOOC", type: "type", color: "indigo", value: "MOOC" },
  ];

  return (
    <Row justify={"center"} align={"middle"} style={{ gap: "0px" }}>
      {types_list.map((item) => {
        return (
          <Tag
            key={item.name}
            onClick={() => {
              marketplaceStore.setActiveFilter(item.name);
              onClick({ order: item.type, value: item.value });
            }}
            color={"white"}
            style={{
              // width: widthTag(),
              // height: heightTag(),
              textAlign: "center",
              cursor: "pointer",
              borderRadius: "15px",
              background:
                marketplaceStore.activeFilter?.toLowerCase() ===
                item.name.toLowerCase()
                  ? "#B701BE"
                  : "linear-gradient(91.2deg, #D045DC 7.47%, #ED9AF4 156.59%)",
              // padding: paddingTag(),
              // fontSize: fontSizeTag(),
              boxSizing: "border-box",
              fontWeight: "300",
              // width: tagStyleBySize[size].width,
              // padding: tagStyleBySize[size].padding,
              // fontSize: tagStyleBySize[size].fontSize,
              // borderRadius: tagStyleBySize[size].borderRadius,
            }}
            className="filter-types"
          >
            {item.name}
          </Tag>
        );
      })}
      {marketplaceStore.activeFilter && (
        <Button onClick={() => OnResetFiltering()}>Clear filters</Button>
      )}
    </Row>
  );
};

export default observer(FilterOptions);
